import {createSelector} from '@ngrx/store';
import {TrainingsState} from "./reducer";
import {selectTrainingsState} from "../selectors";

export const selectCategories = createSelector(
  selectTrainingsState,
  (state: TrainingsState) => state.categories,
);
